<template>
    <div class="idea">
        <div class="tab-box">
                <el-tabs v-model="compName"  >
                    <el-tab-pane name="material">
                        <template #label>
                            <span >工单素材<i class="el-icon-refresh" @click="refreshList"/></span>
                        </template>
                    </el-tab-pane>
                    <el-tab-pane label="本地上传" name="upload"/>
                </el-tabs>
        </div>
        <div class="content">
           <keep-alive>
                <component
                    :is="compName"
                    :fileConfigList="fileConfigList"
                    @upload="handleUploadFile"
                    :uploadFileListCancel="uploadFileListCancel"
                    ref="comp"
                    :hasAll="hasAll"
                    :currentKey="currentKey"
                    @cancelUpload="cancelUpload"
                />
           </keep-alive>
        </div>
    </div>
</template>

<script>
import Material from './material.vue'
import Upload from './upload.vue'
import util from '@/libs/utils'
import API from '@/api/marketManage/oppoBatch';
import axios from 'axios';
export default {
    name: 'IdeaBox',
    components: { Material, Upload },
    props: [ 'config', 'currentKey' ],
    inject: {
        addItem: {
            default: ()=>{}
        },
        hasAll: {
            default: false
        }
    },
    data() {
        return {
            compName: 'material',
            uploadFileListCancelData: {},
            updateFileList: [],
        }
    },
    computed: {
        uploadFileListCancel() {
            return this.uploadFileListCancelData[this.currentKey] || []
        },
        fileConfigList() {
            const list = this.config.map(v=> {
                const {
                    material_type, conf_resolution_ratio, conf_resolution,
                     conf_size_name, conf_length, explicit_name,
                    material_classify_text
                 } = v;
                 const id = util.randomString(20)
                const data = {
                    ...v,
                    id,
                    value: id,
                };
                const conf_format = v.conf_format.split('/').sort().join('/');
                if (material_type === '1') {
                    data.label = `${ material_classify_text }：${conf_resolution}；<${conf_size_name}；${conf_format}`
                }else {
                    data.label = `${ material_classify_text }：${conf_resolution}；<${conf_size_name}；${conf_length}秒；${conf_format}`
                }
                return data
            }).sort((b, a)=> {
                return a.material_type - b.material_type
            });
            const hasData = {};
            const filterList =  list.filter(v=> {
                const has = hasData[v.label];
                if (!has) {
                    hasData[v.label] = true
                }
                return !has;
            });
            if (this.hasAll) {
                const data = {
                    id: 'all',
                    value: 'all',
                    label: '全部'
                };
                filterList.unshift(data)
            }
            return filterList;
        },
    },
    methods: {

        refreshList() {
            if (this.compName === 'material') {
                this.$refs.comp.refreshList()
            }
        },

        // 上传文件

        async handleUploadFile(file, info) {
            let cancel = null;
            try {
                const formData = new FormData();
                formData.append('file', file);
                const { data } = await API.oppoBatchPpload(formData, {
                    cancelToken: new axios.CancelToken( (c)=> {
                        const list = this.uploadFileListCancelData[file.key] || []
                        list.push(cancel = c);
                        this.$set(this.uploadFileListCancelData, file.key, list)
                    }),
                    timeout:3600 * 1000,
                });
                this.addItem({
                    ...data,
                    key: file.key
                }, 'upload', info)
            } catch (error) {
                if (axios.isCancel(error)) {
                    // 上传取消后的逻辑
                }else {
                    console.log(error, '上传出错');
                    this.$message.error(error.info)
                }

            }finally {
                const list = this.uploadFileListCancelData[file.key] || []
                const index = list.indexOf(cancel);
                if (index !== -1) {
                  list.splice(index, 1);
                  this.$set(this.uploadFileListCancelData, file.key, list)
                };
            }
        },
        // 取消全部上传
        cancelUpload() {
            const list = this.uploadFileListCancelData[this.currentKey] || [];
            list.map(v=> {
                v&&v('cancel')
            });
            this.$message.success('已取消上传');
            this.$set(this.uploadFileListCancelData, this.currentKey, [])
        }
    }
}
</script>

<style lang="scss" scoped>
.idea {
    height: 100%;
    display: flex;
    flex-direction: column;
}
.tab-box {
    padding-left: 18px;
   height: 55px;
}
.content {
    padding: 0 10px 10px;
    flex: 1;
    height: 0;
}

</style>
